import { useAppDispatch } from 'reducer';
import { hideDrawer } from 'reducer/slices/drawerSlice';

const Support = () => {
  const dispatch = useAppDispatch();

  return (
    <div className='popup_page contain_center'>
      <div className='back_to_main' onClick={() => dispatch(hideDrawer())}>
        <div className='back_icon'></div>
      </div>
      <h3>پشتیبانی</h3>
      <div className='form'>
        <div className='not_found_item'>
          کانال اطلاع رسانی:
          <br />
          <br />
          <a href='https://t.me/HotVoucher_Supp' target='_blank'>
            HotVoucher_Supp@
          </a>
          <br />
          <br />
          <br />
          <br />
          پشتیبانی:
          <br />
          <br />
          <a href='https://t.me/HotVoucher_Supp' target='_blank'>
            HotVoucher_Supp@
          </a>
        </div>
      </div>
    </div>
  );
};

export default Support;
